import { Module } from '@nestjs/common';
import { KEY_PROVIDER, EnvKeyProvider, PrismaService } from '@cart/api-data-access';
import { AuditService } from '../audit/audit.service';
import { AuthModule } from '../auth/auth.module';
import { NotificationsModule } from '../notifications/notifications.module';
import { MediaAssetService } from './media-asset.service';
import { MediaBackupService } from './media-backup.service';
import { MediaController } from './media.controller';
import { MediaMigrationService } from './media-migration.service';
import { MediaReconciliationService } from './media-reconciliation.service';
import { MediaTrashService } from './media-trash.service';
import { LocalDiskRetirementService } from './local-disk-retirement.service';
import { MediaUploadService } from './media-upload.service';
import { PlatformStorageAdminService } from './platform-storage-admin.service';
import { PlatformStorageController } from './platform-storage.controller';
import { StorageAdapterResolver } from './storage-adapter-resolver.service';
import { StorageConfigService } from './storage-config.service';
import { StorageCredentialVault } from './storage-credential.vault';
import { StorageHealthService } from './storage-health.service';
import { StorageQuotaService } from './storage-quota.service';
import { StorageUrlSweepService } from './storage-url-sweep.service';

/**
 * Media storage, backup and migration.
 *
 * Exported so the product-image path in CommerceAdminModule can write through
 * the same registry and quota rather than keeping a second, divergent notion
 * of what a merchant has stored.
 */
@Module({
  imports: [AuthModule, NotificationsModule],
  controllers: [MediaController, PlatformStorageController],
  providers: [
    PrismaService,
    AuditService,
    { provide: KEY_PROVIDER, useClass: EnvKeyProvider },
    StorageCredentialVault,
    StorageAdapterResolver,
    StorageConfigService,
    StorageQuotaService,
    MediaAssetService,
    MediaUploadService,
    MediaMigrationService,
    MediaReconciliationService,
    MediaTrashService,
    MediaBackupService,
    StorageHealthService,
    StorageUrlSweepService,
    LocalDiskRetirementService,
    PlatformStorageAdminService,
  ],
  exports: [
    MediaTrashService,
    MediaAssetService,
    MediaUploadService,
    StorageQuotaService,
    StorageConfigService,
    StorageAdapterResolver,
    MediaMigrationService,
    StorageUrlSweepService,
    LocalDiskRetirementService,
  ],
})
export class MediaModule {}
